import {
  AreaChart,
  Area,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  YAxis,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-2 rounded-md">
        <p className="label">{`${label}`}</p>
        <p className="value">{`Rp ${payload[0].value.toLocaleString().replaceAll(",", ".")}`}</p>
      </div>
    );
  }

  return null;
};

const Chart = ({ data, dataKeyX, dataKeyY }) => {
  const formatNumber = (number) => {
    const formattedNumber = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(number);

    return formattedNumber;
  };
  return (
    <div>
      <ResponsiveContainer width="100%" aspect={4 / 2}>
        <AreaChart
          height={1000}
          data={data}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis tick={{ fontSize: 10 }} dataKey={dataKeyX} axisLine={{ stroke: "#fff" }} />
          <YAxis
            tickFormatter={formatNumber}
            tick={{ fontSize: 10 }}
            tickMargin={10}
            dataKey={dataKeyY}
            width={115}
            ticks={[2000000, 4000000, 6000000, 8000000]}
            axisLine={{ stroke: "#fff" }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey={dataKeyY}
            stroke="#545DFF"
            strokeWidth={3}
            fill="#CBE4DE"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Chart;
